import React, { Component } from "react";
import Select from "react-select";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#696969",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class MuestraForm extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset className="col-md-12">
            <legend>I. DATOS GENERALES</legend>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="laboratorio">
                    Laboratorio: <span className="text-danger">*</span>
                  </label>
                  <Select
                    id="laboratorio"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    isClearable={true}
                    onChange={this.props.handleLaboratoryChange}
                    theme="neutral40"
                    value={
                      this.props.state.laboratorio !== null ||
                      this.props.state.laboratorio !== ""
                        ? this.props.state.laboratorio
                        : { label: "Seleccione", key: "0" }
                    }
                    options={this.props.state.cat_laboratorio}
                    getOptionLabel={(laboratorio) => laboratorio.descripcion}
                    getOptionValue={(laboratorio) => laboratorio.id}
                    noOptionsMessage={() => "No se encontraron laboratorios"}
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="laboratorio-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="marchamos">Marchamos:</label>
                  <input
                    type="text"
                    maxLength="150"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.marchamos
                    }
                    onChange={this.props.handleInputTextChange}
                    id="marchamos"
                    name="marchamos"
                    placeholder="Ingrese marchamos"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="marchamos-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              {/*<div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="no_recibo">No&#176; Recibo:</label>
                  <input
                    type="text"
                    className="form-control"
                    maxLength="150"
                    value={
                      this.props.state.rel_remision_visita_muestra.no_recibo
                    }
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese número de recibo"
                    id="no_recibo"
                    name="no_recibo"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="no_recibo-error"
                  ></div>
                </div>
                  </div>*/}
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="no_remision">
                    No&#176; Remisión: <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.no_remision
                    }
                    onChange={this.props.handleInputTextChange}
                    id="no_remision"
                    name="no_remision"
                    placeholder="Ingrese número de remisión"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="no_remision-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="fecha_remision">
                    Fecha de remisión: <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra
                        .fecha_remision
                    }
                    onChange={this.props.handleInputTextChange}
                    id="fecha_remision"
                    name="fecha_remision"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="fecha_remision-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="hora_remision">
                    Hora de remisión: <span className="text-danger">*</span>
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.hora_remision
                    }
                    onChange={this.props.handleInputTextChange}
                    id="hora_remision"
                    name="hora_remision"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="hora_remision-error"
                  ></div>
                </div>
              </div>
            </div>

            {/*<div className="row">
            <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="no_solicitud">
                    No. Solicitud: <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength="100"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.no_solicitud
                    }
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese número de solicitud"
                    id="no_solicitud"
                    name="no_solicitud"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="no_solicitud-error"
                  ></div>
                </div>
                  </div>
              
                  </div>*/}
            {/*<div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="fecha_probable_entrega">
                    Fecha probable de entrega:{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra
                        .fecha_probable_entrega
                    }
                    onChange={this.props.handleInputTextChange}
                    id="fecha_probable_entrega"
                    name="fecha_probable_entrega"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="fecha_probable_entrega-error"
                  ></div>
                </div>
                  </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="monto">Monto/Moneda:</label>
                  <input
                    type="text"
                    maxLength="150"
                    className="form-control"
                    value={this.props.state.rel_remision_visita_muestra.monto}
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese monto/moneda"
                    id="monto"
                    name="monto"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="monto-error"
                  ></div>
                </div>
              </div>
                </div>*/}

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="lugar_muestreo">
                    Lugar de muestreo/finca/planta:
                  </label>
                  <input
                    type="text"
                    maxLength="100"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra
                        .lugar_muestreo
                    }
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese lugar"
                    id="lugar_muestreo"
                    name="lugar_muestreo"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="lugar_muestreo-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="cue_cod_ipsa">Cód. IPSA:</label>
                  <input
                    type="text"
                    maxLength="100"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.cue_cod_ipsa
                    }
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese CUE/Cód. IPSA"
                    id="cue_cod_ipsa"
                    name="cue_cod_ipsa"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="cue_cod_ipsa-error"
                  ></div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="comarca">Comarca:</label>
                  <input
                    type="text"
                    maxLength="100"
                    className="form-control"
                    value={this.props.state.rel_remision_visita_muestra.comarca}
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese comarca"
                    id="comarca"
                    name="comarca"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="comarca-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="otro_propietario">Otro propietario:</label>
                  <input
                    type="text"
                    maxLength="100"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra
                        .otro_propietario
                    }
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese otro propietario"
                    id="otro_propietario"
                    name="otro_propietario"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="otro_propietario-error"
                  ></div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="observaciones">Observaciones:</label>
                  <textarea
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.observaciones
                    }
                    onChange={this.props.handleInputTextChange}
                    id="observaciones"
                    name="observaciones"
                    placeholder="Ingrese observaciones"
                  ></textarea>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="observaciones-error"
                  ></div>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend>II. DATOS DE MUESTRA</legend>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="fecha_prod_elab">
                    Fecha de producción/elaboración:{" "}
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra
                        .fecha_prod_elab
                    }
                    onChange={this.props.handleInputTextChange}
                    id="fecha_prod_elab"
                    name="fecha_prod_elab"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="fecha_prod_elab-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="fecha_vencimiento">
                    Fecha de vencimiento:{" "}
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra
                        .fecha_vencimiento
                    }
                    onChange={this.props.handleInputTextChange}
                    id="fecha_vencimiento"
                    name="fecha_vencimiento"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="fecha_vencimiento-error"
                  ></div>
                </div>
              </div>
              
            </div>
            <div className="row">
            <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="no_muestras">
                    No&#176; Muestras: <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength="10"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.no_muestras
                    }
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese número de muestras"
                    id="no_muestras"
                    name="no_muestras"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="no_muestras-error"
                  ></div>
                </div>
              </div>
              {/*<div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="temperatura_levantamiento">
                    Temperatura de levantamiento:{" "}
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      maxLength="100"
                      className="form-control"
                      value={
                        this.props.state.rel_remision_visita_muestra
                          .temperatura_levantamiento
                      }
                      onChange={this.props.handleInputTextChange}
                      placeholder="Ingrese temperatura"
                      id="temperatura_levantamiento"
                      name="temperatura_levantamiento"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        <b>C &#176;</b>
                      </span>
                    </div>
                  </div>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="temperatura_levantamiento-error"
                  ></div>
                </div>
              </div>*/}
              {/*<div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="lote">Lote:</label>
                  <input
                    type="text"
                    maxLength="100"
                    className="form-control"
                    value={this.props.state.rel_remision_visita_muestra.lote}
                    onChange={this.props.handleInputTextChange}
                    id="lote"
                    name="lote"
                    placeholder="Ingrese lote"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="lote-error"
                  ></div>
                </div>
            </div>*/}

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="clasificacion_zootecnica">
                    Clasificación: <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    maxLength="150"
                    value={
                      this.props.state.rel_remision_visita_muestra
                        .clasificacion_zootecnica
                    }
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese función/clasificación zootécnica"
                    id="clasificacion_zootecnica"
                    name="clasificacion_zootecnica"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="clasificacion_zootecnica-error"
                  ></div>
                </div>
              </div>
            </div>

            {/*<div className="row">
              <div className="col-lg-4">
                <div className="form-group">
                  <label htmlFor="temperatura_ingreso">
                    Temperatura de ingreso:{" "}
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="100"
                      value={
                        this.props.state.rel_remision_visita_muestra
                          .temperatura_ingreso
                      }
                      onChange={this.props.handleInputTextChange}
                      placeholder="Ingrese temperatura de ingreso"
                      id="temperatura_ingreso"
                      name="temperatura_ingreso"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        <b>C &#176;</b>
                      </span>
                    </div>
                  </div>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="temperatura_ingreso-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="form-group">
                  <label htmlFor="fecha_ingreso">
                    Fecha de recepción: <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.fecha_ingreso
                    }
                    onChange={this.props.handleInputTextChange}
                    id="fecha_ingreso"
                    name="fecha_ingreso"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="fecha_ingreso-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-2">
                <div className="form-group">
                  <label htmlFor="hora_ingreso">Hora de recepción:</label>
                  <input
                    type="time"
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.hora_ingreso
                    }
                    onChange={this.props.handleInputTextChange}
                    id="hora_ingreso"
                    name="hora_ingreso"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="hora_ingreso-error"
                  ></div>
                </div>
                  </div>
              <div className="col-lg-2">
                <div className="form-group">
                  <label htmlFor="id_mx">
                    ID MX: <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.props.state.rel_remision_visita_muestra.id_mx}
                    onChange={this.props.handleInputTextChange}
                    id="id_mx"
                    name="id_mx"
                    placeholder="Ingrese ID MX"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="id_mx-error"
                  ></div>
                </div>
              </div>
                  </div>*/}
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="proposito">Uso/Propósito:</label>
                  <textarea
                    className="form-control"
                    value={
                      this.props.state.rel_remision_visita_muestra.proposito
                    }
                    onChange={this.props.handleInputTextChange}
                    placeholder="Ingrese uso/propósito"
                    id="proposito"
                    name="proposito"
                  ></textarea>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="proposito-error"
                  ></div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </>
    );
  }
}

export default MuestraForm;
